export default {
  title: 'Kontakt Info',
  form: {
    customer_first_name: {
      placeholder: 'Vornamen',
    },
    customer_last_name: {
      placeholder: 'Nachname',
    },
    customer_email: {
      placeholder: 'Email Adresse',
    },
    customer_phone_number: {
      placeholder: 'Rufnummer',
    },
  },
  validation: {
    customer_first_name: {
      required: 'Bitte gib deinen Vornamen ein',
    },
    customer_last_name: {
      required: 'Bitte gib deinen Nachnamen ein',
    },
    customer_email: {
      required: 'Bitte gib deine Email ein',
    },
    customer_phone_number: {
      required: 'Bitte gib deine Rufnummer ein',
    },
  },
};
